import fe, { info } from "@randajan/simple-app/fe";
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App/App';
import initAnalytics from './jReact/Analytics';
import jet from "@randajan/jet-core";

import './index.css';


//initAnalytics(info.analytics, info.stage !== "prod");

createRoot(document.getElementById("root")).render(<App />);